import { i18n } from '@mdc/services';

export default [
    {
        translationKey: i18n.t('Multiscanning'),
        param: 'rule',
        value: 'multiscan',
    },
    {
        translationKey: i18n.t('Proactive DLP'),
        param: 'rule',
        value: 'dlp',
        disabled: 'true'
    },
    {
        translationKey: i18n.t('Unarchiving'),
        param: 'rule',
        value: 'unarchive'
    },
    {
        translationKey: i18n.t('Deep CDR'),
        param: 'rule',
        value: 'cdr'
    },
    {
        translationKey: i18n.t('Hash Lookup'),
        param: 'hash-lookup',
        value: 'true',
        disabled: 'true'
    },
    {
        translationKey: i18n.t('Sandbox'),
        param: 'sandbox',
        value: [
            {
                fieldName: i18n.t('Operating system'),
                values: [
                    { key: 'windows10', translationKey: i18n.t('Windows 10') },
                    { key: 'windows7', translationKey: i18n.t('Windows 7') }
                ],
                param: 'sandbox_os'
            },

            {
                fieldName: i18n.t('Duration'),
                values: [
                    { key: 'short', translationKey: i18n.t('Short analysis') },
                    { key: 'long', translationKey: i18n.t('Long analysis') }
                ],
                param: 'sandbox_timeout',
            },

            {
                fieldName: i18n.t('Browser'),
                values: [
                    { key: 'os_default', translationKey: i18n.t('OS_default') },
                    { key: 'chrome', translationKey: i18n.t('Chrome') },
                    { key: 'firefox', translationKey: i18n.t('Firefox') }
                ],
                param: 'sandbox_browser',
            }
        ]
    },
    {
        translationKey: i18n.t('Private processing'),
        param: 'privateprocessing',
        value: '1',
        paidOnly: 'true',
        paidDescription: i18n.t('Private processing is only available for Commercial and Enterprise users')
    },
    {
        translationKey: i18n.t('Archive password'),
        param: 'archivepwd',
        value: '',
        pwdProtectedOnly: 'true'
    }
];
